const navigationTiming = (trackPerformanceNavigationTimingEvent) => {
  if ('PerformanceNavigationTiming' in window) {
    const track = () => {
      const [ entry ] = performance.getEntriesByType('navigation');

      trackPerformanceNavigationTimingEvent({
        /*
         PerformanceEntry layer
         https://www.w3.org/TR/performance-timeline-2/#the-performanceentry-interface
         */
        timing_duration: entry.duration,
        timing_name: entry.name,
        timing_start_time: entry.startTime,
        timing_type: entry.entryType,
        /*
         PerformanceResourceTiming layer
         https://www.w3.org/TR/resource-timing-1/#h-performanceresourcetiming
         Also, Null values below are from the draft version of Resource Timing Level 2:
         https://w3c.github.io/resource-timing/#sec-performanceresourcetiming
        */
        resource_connect_end: entry.connectEnd,
        resource_connect_start: entry.connectStart,
        resource_decoded_body_size: entry.decodedBodySize === undefined
          ? null
          : entry.decodedBodySize,
        resource_domain_lookup_end: entry.domainLookupEnd,
        resource_domain_lookup_start: entry.domainLookupStart,
        resource_encoded_body_size: entry.encodedBodySize === undefined
          ? null
          : entry.encodedBodySize,
        resource_fetch_start: entry.fetchStart,
        resource_initiator_type: entry.initiatorType,
        resource_next_hop_protocol: entry.nextHopProtocol === undefined
          ? null
          : entry.nextHopProtocol,
        resource_redirect_end: entry.redirectEnd,
        resource_redirect_start: entry.redirectStart,
        resource_request_start: entry.requestStart,
        resource_response_end: entry.responseEnd,
        resource_response_start: entry.responseStart,
        resource_secure_connection_start: entry.secureConnectionStart === undefined
          ? null
          : entry.secureConnectionStart,
        resource_transfer_size: entry.transferSize === undefined
          ? null
          : entry.transferSize,
        resource_worker_start: entry.workerStart === undefined
          ? null
          : entry.workerStart,
        /*
         PerformanceNavigationTiming layer
         https://www.w3.org/TR/navigation-timing-2/
         */
        navigation_dom_complete: entry.domComplete,
        navigation_dom_content_loaded_event_end: entry.domContentLoadedEventEnd,
        navigation_dom_content_loaded_event_start: entry.domContentLoadedEventStart,
        navigation_dom_interactive: entry.domInteractive,
        navigation_load_event_end: entry.loadEventEnd,
        navigation_load_event_start: entry.loadEventStart,
        navigation_redirect_count: entry.redirectCount,
        navigation_type: entry.type,
        navigation_unload_event_end: entry.unloadEventEnd,
        navigation_unload_event_start: entry.unloadEventStart,
      });
    };

    if (document.readyState === 'complete') {
      track();
    } else {
      /*
      Using requestAnimationFrame here because the value for entry.loadEventEnd will be 0 (tested
      in Chrome) if we don't invoke after the currently executing script is complete.
      */
      window.addEventListener('load', () => requestAnimationFrame(track));
    }
  }
};

export default navigationTiming;
